import { createFileRoute } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { getBookingQueryOptions } from '@/queries/query'
import BookingDetail from '@/components/my-booking/booking-detail'

export const Route = createFileRoute('/manage-booking/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })

  const {
    data: { data: bookingData },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))

  return (
    <BookingDetail
      parentTo="/manage-booking"
      parentTitle="Manage Booking"
      booking={bookingData.booking}
    />
  )
}
